<!-- <div class="disableLayer" [style.height]="heightLayer" [style.bottom.px]="cameraType == 'rtsp' ? '0' : 'inherit'"></div> -->
<div class="disableLayer" *ngIf="cameraType != 'rtsp' && cameraType != 'antmedia'"></div>

<div class="civix-controls" *ngIf="addCloseButton || cameraType === 'civix-rtmp' || showLocateButton">
  <button *ngIf="addCloseButton" type="button" class="civix-close-toggle"
    (click)="closeButtonClicked.emit(_id)">
    <mat-icon style="font-size: 1.3rem;">close</mat-icon>
  </button>
  <button *ngIf="cameraType === 'civix-rtmp'" type="button" class="civix-mute-toggle"
    (click)="toggleCivixMute($event)" [attr.aria-label]="muted ? 'Unmute stream' : 'Mute stream'">
    <mat-icon style="font-size: 1.3rem;">{{ muted ? 'volume_off' : 'volume_up' }}</mat-icon>
  </button>
  <button *ngIf="showLocateButton" type="button" class="locate-camera-toggle"
    (click)="onLocateClick($event)" [matTooltip]="'Locate camera on map' | translate">
    <mat-icon style="font-size: 1.3rem;">place</mat-icon>
  </button>
  <!-- <button *ngIf="showStopButton && stream_type == 'rtmp/rtsp'" type="button" class="stop-camera-toggle"
    (click)="onStopStreamClick($event)" aria-label="Stop camera">
    <mat-icon style="font-size: 1.3rem;">stop</mat-icon>
  </button> -->
</div>
<div class="showingLayer">
  <img *ngIf="cameraType === 'default'" style="width: 100%;" src="{{value}}" alt="{{name}}">
  <div [hidden]="cameraType != 'rtsp'" #rtspVideo style="height: 100%;"></div>
  <iframe *ngIf="cameraType === 'vimeo' && iframe_html && originalUrl" [src]="iframe_html" width="100%" height="100%" frameborder="0"
    allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
  <iframe *ngIf="cameraType === 'youtube' && iframe_html && originalUrl" width="100%" height="100%" [src]="iframe_html"
    title="YouTube video player" frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
  <iframe *ngIf="cameraType === 'antmedia' && iframe_html && originalUrl" width="100%" height="100%" [src]="iframe_html"
    frameborder="0" allowfullscreen [attr.muted]="muted ? '' : null" [attr.mute]="muted ? '' : null"></iframe>
  <iframe *ngIf="cameraType === 'civix-rtmp' && iframe_html" width="100%" height="100%" [src]="iframe_html"
    frameborder="0" allowfullscreen [attr.muted]="muted ? '' : null" [attr.mute]="muted ? '' : null" allow="autoplay"></iframe>
</div>